// @ts-nocheck
import SceneLayer from "./layer";

export default class SceneLayerCanvasGeom extends SceneLayer {
	/**
	 * Vytvoreni vrstvy pro zobrazeni svg geometrii pomoci canvasu.
	 */
	constructor(scene, itemId, id, options = {}) {
		super(scene, itemId, id);

		this._data = null;
		this._options = options;
		this._geometries = [];
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerCanvasGeom",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.geometries = this._geometries;
		rd.options = this._options;
		rd.data = this._data;

		return rd;
	}

	/**
	 * Smazani vsech entit vrstvy.
	 */
	removeAll(...args) {
		while (this._geometries.length) {
			const geom = this._geometries.shift();

			geom.sceneOwner = null;
		}

		this._geometries.length = 0;

		this._onChange(this._scene.featureEvent("layerRemoveAll", true, true), args);
	}

	redraw() {
		this._drawGeometries();
		super.redraw();
	}

	addGeometry(geom) {
		this.addSmartGeometry(geom);
	}

	removeGeometry(geom) {
		this.removeSmartGeometry(geom);
	}

	addSmartGeometry(geom) {
		const ind = this._geometries.indexOf(geom);

		if (ind === -1) {
			geom.sceneOwner = this;

			this._geometries.push(geom);
			this._drawGeometries();
		}
	}

	removeSmartGeometry(geom) {
		const ind = this._geometries.indexOf(geom);

		if (ind !== -1) {
			geom.sceneOwner = null;

			this._geometries.splice(ind, 1);
			this._drawGeometries();
		}
	}

	geometryOnCursor(...args) {
		return this._onChange(this._scene.featureEvent("layerCanvasGeomGeometryOnCursor", true, true), args);
	}

	getCanvas(...args) {
		return this._onChange(this._scene.featureEvent("layerCanvasGeomGetCanvas", true, true), args);
	}

	up(...args) {
		return this._onChange(this._scene.featureEvent("layerCanvasGeomUp", true, true), args);
	}

	down(...args) {
		return this._onChange(this._scene.featureEvent("layerCanvasGeomDown", true, true), args);
	}

	fillFromData(...args) {
		this._data = JSON.parse(JSON.stringify(args[0]));

		return this._onChange(this._scene.featureEvent("layerFillFromData", true, true), args);
	}

	_drawGeometries() {
		this._onChange(this._scene.featureEvent("layerCanvasGeomDrawGeometries", true, true), [this._geometries]);
	}
}
